// extracted by mini-css-extract-plugin
export default {"not-found":"not-found_not-found__Ws1jU"};